/**
 * CartSummary - Compact cart summary bar at the bottom of the ecommerce area.
 * Shows item count, total, and a "View Cart" link. Hidden when cart is empty.
 */
export class CartSummary {
  constructor() {
    this.element = null;
    this.itemCount = 0;
    this.total = 0;
    this.currency = '$';
    this.cartUrl = '/cart';
  }

  render() {
    const el = document.createElement('div');
    el.className = 'ttp-cart-summary ttp-cart-empty';
    el.style.display = 'none';

    el.innerHTML = `
      <div class="ttp-cart-info">
        <span class="ttp-cart-icon" data-ttp-fly-target>\uD83D\uDED2</span>
        <span class="ttp-cart-count">0 items</span>
        <span class="ttp-cart-separator">\u00B7</span>
        <span class="ttp-cart-total">${this.currency}0.00</span>
      </div>
      <a class="ttp-cart-view" href="${this.cartUrl}" target="_top">View Cart \u203A</a>
    `;

    this.element = el;
    return el;
  }

  update(itemCount, total, currency) {
    this.itemCount = itemCount;
    this.total = total;
    if (currency) this.currency = currency;

    if (this.element) {
      /* Use setProperty('important') to override display:flex !important in CSS */
      this.element.style.setProperty('display', itemCount > 0 ? 'flex' : 'none', 'important');
      this.element.classList.toggle('ttp-cart-empty', itemCount === 0);
      this.element.querySelector('.ttp-cart-count').textContent =
        `${itemCount} item${itemCount !== 1 ? 's' : ''}`;
      this.element.querySelector('.ttp-cart-total').textContent =
        `${this.currency}${total.toFixed(2)}`;
    }
  }
}
